<template lang="pug">
  v-container.pt-6.px-10(fluid)
    v-breadcrumbs.pt-0.px-0.pb-3(:items="breadcrumbItems")
      template(v-slot:item="{ item }")
        a.text-sm.font-medium.no-underline.neutral700--text(v-if="!item.disabled" @click="item.href") {{ item.text }}
        .text-sm.neutral700--text(v-else) {{ item.text }}

    div.d-flex.justify-center.mt-16(v-if="isFetching")
      v-progress-circular(:width="2" :size="50" color="primary" indeterminate)
    template(v-else)
      div.d-flex.align-center
        v-btn.ml-n3(text icon @click="goBack" height)
          v-icon(color="neutral700" :size="24") mdi-arrow-left
        .text-2xl.font-semibold.neutral700--text.ml-3(v-if="medicine") {{ medicine.name }}
        .text-lg.font-semibold.neutral500--text.ml-3(v-if="displayUom") ( {{ displayUom }} )
      v-row.pb-2.pb-md-0(no-gutters)
        v-col
          v-tabs(v-model="tabs" color="basic700" :height="44" :grow="isMobileScreen" grow)
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") All
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Stock received
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Inventory re-count
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Damage
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Theft
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Loss
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Expired
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Stock return
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Sales
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Stock take
            v-tab.text-sm.font-semibold.text-none.px-0(style="min-width: unset;") Clinic use
        v-col(cols="3")
          .d-flex.align-center
            v-spacer
            //- v-btn(@click="clickSearch" icon color="neutral500")
            //-   v-icon(size="20") $yzi-search-sm
            //- v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
            y-button.ml-4(label="Download Excel" size="sm" :loading="isLoading" @click="downloadData")
          
      v-divider

      .data-table
        v-data-table.mt-sm-4.pb-6(:headers="headers" :items="inventories" item-key="id" :items-per-page="pageSize" hide-default-footer :loading="isFetchingInventories" :disable-sort="isMobileScreen" :header-props="{ sortIcon: '$yzi-triangle' }")
          //- date time
          template(v-slot:item.created="{ item }")
            .text-sm.neutral700--text {{ item.created | convertServerDate2 }}
          //- change
          template(v-slot:item.change="{ item }")
            .text-sm.neutral700--text {{ item.change > 0 ? `+${item.change}` : item.change }}
          //- cost
          template(v-slot:item.cost="{ item }")
            template(v-if="item.action === 'received'")
              .text-sm.neutral700--text.no-wrap(v-if="item.purchase_item") {{ item.purchase_item.cost_per_item * item.change | displayPrice }}
              .text-sm.neutral700--text.no-wrap(v-else) {{ item.cost | displayPrice }}
          //- cost per item
          template(v-slot:item.cost_per_item="{ item }")
            template(v-if="item.action === 'received'")
              .text-sm.neutral700--text.no-wrap(v-if="item.purchase_item") {{ item.purchase_item.cost_per_item | displayPrice }}
              .text-sm.neutral700--text.no-wrap(v-else) {{ getCostPerItem(item.change, item.cost) | displayPrice }}
          //- invoice date
          template(v-slot:item.invoice_date="{ item }")
            .text-sm.neutral700--text(v-if="item.invoice") {{ item.invoice.record_date | humanizeDate }}
            .text-sm.neutral700--text(v-else-if="item.invoice_date") {{ item.invoice_date | humanizeDate }}
          //- document no
          template(v-slot:item.document_no="{ item }")
            .text-sm.neutral700--text {{ getDocumentNo(item) }}
          //- sellers
          template(v-slot:item.seller="{ item }")
            template(v-if="item.invoice")
              template(v-if="item.purchase_item")
                div.my-1
                  .text-sm.neutral700--text(v-if="item.invoice.supplier.value") {{ item.invoice.supplier.value }}
                  .text-xs.neutral500--text(v-if="item.invoice.supplier.extra_data")
                    span {{ item.invoice.supplier.extra_data.name }}
                    span(v-if="item.invoice.supplier.extra_data.name && item.invoice.supplier.extra_data.phone") &nbsp;(+{{ item.invoice.supplier.extra_data.phone }})
                    span(v-else-if="item.invoice.supplier.extra_data.phone") +{{ item.invoice.supplier.extra_data.phone }}
              template(v-else-if="item.invoice.seller")
                div.my-1
                  .text-sm.neutral700--text(v-if="item.invoice.seller.sold_by") {{ item.invoice.seller.sold_by }}
                  .text-xs.neutral500--text
                    span {{ item.invoice.seller.name }}
                    span(v-if="item.invoice.seller.name && item.invoice.seller.phone") &nbsp;(+{{ item.invoice.seller.phone }})
                    span(v-else-if="item.invoice.seller.phone") +{{ item.invoice.seller.phone }}
            template(v-else-if="item.action === 'sales'")
              div.my-1(v-if="item.lead")
                .text-sm.neutral700--text {{ item.lead.name }}
                .text-xs.neutral500--text {{ item.lead.ic }}
            div.my-1(v-else-if="item.manufacturer && Object.keys(item.manufacturer).length > 0")
              .text-sm.neutral700--text {{ item.manufacturer.sold_by }}
              .text-xs.neutral500--text
                span {{ item.manufacturer.name }}
                span(v-if="item.manufacturer.name && item.manufacturer.phone") &nbsp;(+{{ item.manufacturer.phone }})
                span(v-else-if="item.manufacturer.phone") +{{ item.manufacturer.phone }}
          template(v-slot:item.remarks="{ item }")
            v-tooltip(top color="neutral700")
              template(#activator="{ on, attrs }")
                div(v-bind="attrs" v-on="on" style="max-width: 175px;")
                  .text-sm.neutral700--text.cursor-help.ellipsis-text {{ item.remarks }}
              div.text-xs(style="max-width: 500px;") {{ item.remarks }}
          //- actions
          template(v-slot:item.actions="{ item, index }")
            v-menu(v-if="item.action === 'received'" offset-y :top="menuPositionTop(index)" left attach rounded="lg")
              template(#activator="{ on }")
                v-btn(icon small v-on="on")
                  v-icon mdi-dots-horizontal
              v-list.py-0
                template(v-if="item.purchase_item")
                  v-list-item(@click="viewStock(item)")
                    v-list-item-title.text-sm.basic800--text View item
                v-list-item(@click="editStock(item)")
                  v-list-item-title.text-sm.basic800--text Edit item

      div.d-flex.align-center(v-if="totalCount > pageSize")
        v-spacer
        yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")

    .dialogs
      edit-stock-dialog(v-if="openEditStockDialog" :open.sync="openEditStockDialog" :product="medicine.product" :stock="selectedStock" @update="stockUpdated()" @closed="closeUpdateStock()")
      view-stock-dialog(v-if="openViewStockDialog" :open.sync="openViewStockDialog" :product="medicine.product" :stock="selectedStock" @closed="closeViewStock()")

</template>

<script>
import { debounce } from '@/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
import EditStockDialog from '@/components/clinic/inventory/EditStockDialog.vue'
import ViewStockDialog from "@/components/clinic/inventory/ViewStockDialog.vue";


export default {
  name: 'StockHistory',
  components: { EditStockDialog, ViewStockDialog },
  props: ['id'],
  data () {
    return {
      showSearchField: false,
      isFetching: false,
      isFetchingInventories: false,
      isLoading: false,
      openEditStockDialog: false,
      openViewStockDialog: false,
      tabs: 0,
      pageSize: 20,
      searchText: '',
      totalCount: 0,
      currentPage: 1,
      medicine: null,
      selectedStock: null,
      inventories: [],
      headers: [
        { text: 'Date and time', value: 'created', enable: true, class: 'text-table-header' },
        { text: 'Stock action', value: 'action_display', enable: true, class: 'text-table-header' },
        { text: 'Changes', value: 'change', enable: true, class: 'text-table-header' },
        { text: 'Total cost', value: 'cost', enable: true, class: 'text-table-header' },
        { text: 'Cost per item', value: 'cost_per_item', enable: true, class: 'text-table-header' },
        { text: 'Document no', value: 'document_no', enable: true, class: 'text-table-header' },
        { text: 'Document date', value: 'invoice_date', enable: true, class: 'text-table-header' },
        { text: 'Seller / patient', value: 'seller', enable: true, class: 'text-table-header' },
        { text: 'Remarks', value: 'remarks', enable: true, class: 'text-table-header' },
        { text: '', value: 'actions', enable: true, class: 'text-table-header', sortable: false },
      ],
      breadcrumbItems: [
        { text: 'Inventory', disabled: false, href: () => (this.goToInventory()) },
        { text: 'Stock history', disabled: true }
      ]
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({ company: 'getCompany' }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    displayUom () {
      const product = this.medicine?.product
      if (!product) return ''
      if (product.uom_conversion_enabled && product.uom_conversions?.length > 0) {
        return product.uom_conversions[product.uom_conversions.length - 1].convert_to
      }
      return product.uom || ''
    },
  },
  watch: {
    tabs () {
      this.searchText = null
      this.currentPage = 1
      this.fetchMedicationInventories()
    },
    pageSize () {
      this.currentPage = 1
      this.fetchMedicationInventories()
    }
  },
  mounted () {
    this.fetchMedication()
    this.fetchMedicationInventories()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMedication () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}/medications/${this.id}`)
        .then(resp => {
          this.medicine = resp.data
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    fetchMedicationInventories () {
      this.isFetchingInventories = true
      let params = {
        page_size: this.pageSize,
        page: this.currentPage,
        ordering: '-created'
      }
      if (this.tabs === 1) { params.action = 'received' }
      if (this.tabs === 2) { params.action = 're-count' }
      if (this.tabs === 3) { params.action = 'damage' }
      if (this.tabs === 4) { params.action = 'theft' }
      if (this.tabs === 5) { params.action = 'loss' }
      if (this.tabs === 6) { params.action = 'expired' }
      if (this.tabs === 7) { params.action = 'return' }
      if (this.tabs === 8) { params.action = 'sales' }
      if (this.tabs === 9) { params.action = 'stock_take' }
      if (this.tabs === 10) { params.action = 'use' }
      if (this.searchText) { params.search = this.searchText }
      this.$axios.get(`/clinics/${this.company.slug}/medications/${this.id}/inventories`, { params })
        .then(resp => {
          this.inventories = resp.data.results
          this.totalCount = resp.data.count
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingInventories = false
        })
    },
    queryChanged: debounce(function () {
      this.currentPage = 1
      this.fetchMedicationInventories()
    }, 750),
    pageChanged () {
      this.fetchMedicationInventories()
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    getCostPerItem (change, cost) {
      let stockChange = change || 0
      let stockCost = cost || 0
      let costPerItem = Number(stockCost) / (Number(stockChange) || 1)
      return costPerItem.toFixed(2)
    },
    downloadData () {
      this.isLoading = true
      let params = {}
      if (this.tabs === 1) { params.action = 'received' }
      if (this.tabs === 2) { params.action = 're-count' }
      if (this.tabs === 3) { params.action = 'damage' }
      if (this.tabs === 4) { params.action = 'theft' }
      if (this.tabs === 5) { params.action = 'loss' }
      if (this.tabs === 6) { params.action = 'expired' }
      if (this.tabs === 7) { params.action = 'return' }
      if (this.tabs === 8) { params.action = 'sales' }
      if (this.tabs === 9) { params.action = 'stock_take' }
      if (this.tabs === 10) { params.action = 'use' }
      let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
      let exportDomain
      if (process.env.VUE_APP_ENV === 'prod') {
        exportDomain = 'https://export.yezza.io'
      } else {
        exportDomain = 'https://export-test.yezza.io'
      }
      this.$axios.post(`/users/${this.user.id}/request_otk/`)
        .then(response => {
          const exportUrl = `${exportDomain}/products/${this.medicine.product.id}/inventories/export_csv?${queryString}&key=${response.data.key}`
          window.open(exportUrl, '_self')
        }).catch(() => {})
        .finally(() => {
          this.isLoading = false
        })
    },
    menuPositionTop (index) {
      let position = index + 1
      if (position > 7) {
        let start = this.inventories.length - 3
        if (position > start) {
          return true
        }
      }
      return false
    },
    editStock (item) {
      if (item.purchase_item) {
        const tab = item.purchase_item.order ? 'purchaseOrder' : 'invoice'
        const id = item.purchase_item.order ? item.purchase_item.order : item.purchase_item.invoice
        this.$router.push(`/admin/clinic/purchase-hub?tab=${tab}&id=${id}`)
        return
      }
      this.selectedStock = item
      this.openEditStockDialog = true
    },
    viewStock (item) {
      this.selectedStock = item
      this.openViewStockDialog = true
    },
    stockUpdated () {
      this.closeUpdateStock()
      this.fetchMedicationInventories()
    },
    closeUpdateStock () {
      this.selectedStock = null
      this.openEditStockDialog = false
    },
    closeViewStock () {
      this.selectedStock = null
      this.openViewStockDialog = false
    },
    getDocumentNo (item) {
      if (!item.purchase_item) {
        return item.invoice_no
      }
      let header
      if (item.purchase_item.invoice) header = 'INV'
      if (item.purchase_item.order) header = 'PO'
      return `${header} #${item.invoice_no}`
    },
    goBack () {
      let route = { name: 'ClinicInventory' }
      if (this.$route?.params?.origin) {
        route = { name: this.$route.params.origin }
      }
      if (this.$route?.params?.data && Object.keys(this.$route.params.data).length) {
        route = { ...route, ...this.$route.params.data }
      }
      return this.$router.push(route).catch(() => {})
    },
    goToInventory () {
      let route = { name: 'ClinicInventory' }
      if (this.$route?.params?.data && Object.keys(this.$route.params.data).length) {
        if (this.$route?.params?.origin !== 'ClinicInventory') {
          if (this.$route.params.data?.params?.data && Object.keys(this.$route.params.data.params.data).length) {
            route = { ...route, ...this.$route.params.data.params.data }
          }
        } else {
          route = { ...route, ...this.$route.params.data }
        }
      }
      return this.$router.push(route).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-width {
  width: 50px !important;
}
</style>